import { fmtCompact } from "../../lib/format";
import type { MaturityBucket } from "./dashboardData";

// Bar-chart по срокам до погашения. Высота каждого бара = доля в максимуме.
// Если все бакеты пустые (нет данных или days_to_maturity = null) — пустая
// ось без баров, чтобы пользователь видел сам факт «по срокам».
export function MaturityBuckets({ buckets }: { buckets: MaturityBucket[] }) {
  const max = buckets.reduce((m, b) => Math.max(m, b.rub), 0);

  return (
    <div className="card" style={{ padding: 16 }}>
      <div className="serif" style={{ fontSize: 20, marginBottom: 10 }}>
        По срокам до погашения
      </div>
      <div className="bars" style={{ height: 140 }}>
        {buckets.map((b) => {
          const pct = max > 0 ? (b.rub / max) * 100 : 0;
          return (
            <div
              key={b.label}
              className={`bar ${b.rub === 0 ? "empty" : ""}`}
              style={{ height: `${Math.max(pct, b.rub > 0 ? 4 : 0)}%` }}
            >
              {b.rub > 0 && <span className="vlbl">{fmtCompact(b.rub)}</span>}
              <span className="xlbl">{b.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
